import { Minus, Plus } from "lucide-react";

const CHIPS = [1, 5, 10, 50, 100];
const clamp = (v) => Math.min(500, Math.max(0.2, Math.round(v * 100) / 100));

export const BetControl = ({ value, onChange, disabled, testid = "bet" }) => (
  <div className="space-y-2">
    <div className="flex items-center gap-2">
      <button type="button" disabled={disabled} onClick={() => onChange(clamp(value / 2))} className="btn-ghost rounded-full p-2 disabled:opacity-40" data-testid={`${testid}-half`}><Minus size={14} /></button>
      <input type="number" disabled={disabled} value={value} onChange={(e) => onChange(Number(e.target.value))} onBlur={() => onChange(clamp(value || 0.2))}
        className="jp-input text-center font-display !py-2" data-testid={`${testid}-input`} />
      <button type="button" disabled={disabled} onClick={() => onChange(clamp(value * 2))} className="btn-ghost rounded-full p-2 disabled:opacity-40" data-testid={`${testid}-double`}><Plus size={14} /></button>
    </div>
    <div className="grid grid-cols-5 gap-1.5">
      {CHIPS.map((c) => (
        <button type="button" key={c} disabled={disabled} onClick={() => onChange(c)}
          className={`rounded-lg py-1.5 text-xs font-semibold transition-colors disabled:opacity-40 ${value === c ? "bg-[#D4AF37] text-black" : "bg-white/5 hover:bg-white/10"}`}
          data-testid={`${testid}-chip-${c}`}>{c}</button>
      ))}
    </div>
  </div>
);
